import { takeEvery } from "redux-saga/effects";
import openSocket from "socket.io-client";

import getStore from "../../store";
import { appConstants } from "../constants";
import { appReloadConfig, appReceivedConfig } from "../actions/app";
import endpoints from "../../api/endpoints";

let socket = null;

export const connect = () => {
	if (socket !== null) {
		return;
	}

	const query = {
		protocol: "sio1",
		tenantId: process.env.REACT_APP_CLIENT_ID
	};

	socket = openSocket(endpoints.betsApiUrl, {
		path: "/betsapi/ws",
		forceNew: true,
		transports: ["websocket"],
		query
	});

	socket.on("connect", () => { });

	socket.on("event", (data) => { });

	socket.on("error", error => { });

	socket.on("connect_error", error => { });

	socket.on("reload_config", data => {
		getStore().dispatch(appReloadConfig());
	});

	socket.on("update_landing_pages_config", data => {
		getStore().dispatch(appReceivedConfig(data));
	});
};

export const disconnect = () => {
	if (socket !== null) {
		socket.disconnect();
		socket = null;
	}
};


function* appInitializeSaga() {
	yield connect();
}

export default function* watchWS() {
	yield takeEvery(appConstants.INITIALIZE, appInitializeSaga);
}
